export type UpdateApplySafety = { safe: boolean; reason?: 'recording' | 'playback' | 'unsaved' | 'busy'; message?: string }
const activities = new Set<string>()
let applying = false
let started = false
let dirtyFields = new Set<Element>()
let dirtyRoute = ''

/** Native recorder/long operations may register a blocker independently of DOM. */
export function setUpdateActivity(key: string, busy: boolean) { if (busy) activities.add(key); else activities.delete(key) }
export function setUpdateApplying(active: boolean) { applying = active }
export function isUpdateApplying() { return applying }
export function startUpdateSafety() {
  if (started || typeof window === 'undefined') return
  started = true
  dirtyRoute = window.location.hash
  const changed = (event: Event) => {
    const target = event.target
    if (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement || target instanceof HTMLElement && target.isContentEditable) dirtyFields.add(target)
  }
  document.addEventListener('input', changed, true)
  document.addEventListener('change', changed, true)
  window.addEventListener('hashchange', () => { dirtyRoute = window.location.hash; dirtyFields.clear() })
}

/** No reload is allowed when safety cannot be established. No user data is changed. */
export function getUpdateApplySafety(): UpdateApplySafety {
  startUpdateSafety()
  try {
    if (typeof document === 'undefined' || typeof window === 'undefined') return { safe: false, reason: 'busy', message: '앱 상태를 확인한 뒤 다시 시도해 주세요.' }
    const route = window.location.hash.split('?')[0]
    if (/^#\/(?:voice-record|voice-review)(?:\/|$)/.test(route) || document.querySelector('.is-recording') || [...activities].some(key => /record/i.test(key))) return { safe: false, reason: 'recording', message: '녹음과 원본 확인을 마친 뒤 다른 화면에서 적용해 주세요.' }
    if ([...document.querySelectorAll('audio, video')].some(media => media instanceof HTMLMediaElement && !media.paused && !media.ended)) return { safe: false, reason: 'playback', message: '동화를 잠시 멈춘 뒤 적용해 주세요.' }
    if (dirtyRoute !== window.location.hash) { dirtyRoute = window.location.hash; dirtyFields.clear() }
    dirtyFields = new Set([...dirtyFields].filter(field => field.isConnected))
    if (dirtyFields.size) return { safe: false, reason: 'unsaved', message: '입력한 내용을 저장하고 다른 화면으로 이동한 뒤 적용해 주세요.' }
    if (applying || activities.size || /^#\/(?:preparing|checkout)(?:\/|$)/.test(route) || document.querySelector('[aria-busy="true"]')) return { safe: false, reason: 'busy', message: '진행 중인 작업이 끝나면 적용할 수 있어요.' }
    return { safe: true }
  } catch { return { safe: false, reason: 'busy', message: '앱 상태를 확인하지 못했어요. 다음 실행 때 적용할게요.' } }
}
export function updateBlockReason() { return getUpdateApplySafety().message }
